import React  from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const SubHeader = () => {

    return (
        <Card sx={{ background: "transparent", padding: '16px', boxShadow: 'none' }}>
            <CardContent>
                <Typography textAlign="center" variant="h1" color="white">
                    AGENDA TU HORA
                </Typography>
            </CardContent>
        </Card>
    );
}

export default SubHeader;